import styled, { css } from 'styled-components'
import { animated } from 'react-spring'

interface ContainerProps {
  type?: 'success' | 'error' | 'info'
  hasDescription: boolean
}

const toastTypes = {
  info: css`
    background: #ebf8ff;
    color: #3172b7;
  `,
  success: css`
    background: #e6fffa;
    color: #2e656a;
  `,
  error: css`
    background: #fddede;
    color: #c53030;
  `
}

export const Container = styled(animated.div)<ContainerProps>`
  width: 360px;
  @media (max-width: 900px) {
    width: 80%;
  }

  position: relative;
  padding: 16px 30px 16px 16px;
  border-radius: 10px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
  display: flex;

  & + div {
    margin-top: 8px;
  }

  ${(props) => toastTypes[props.type || 'info']}

  > svg {
    margin: 4px 12px 0 0;
  }

  div.content {
    flex: 1;
    display: flex;
    flex-direction: column;

    p {
      margin-top: 4px;
      font-size: 14px;
      opacity: 0.8;
      line-height: 20px;
    }

    .toast-actions {
      margin-top: 8px;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      button {
        background: transparent;
        border: 1px solid #2e656a;
        padding: 6px 12px;
        border-radius: #2e656a;
        color: #2e656a;
        cursor: pointer;
        font-size: 14px;

        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
      }
    }
  }

  button.close-button {
    position: absolute;
    right: 16px;
    top: 19px;
    opacity: 0.6;
    border: 0;
    background: transparent;
    color: inherit;
  }

  ${(props) =>
    !props.hasDescription &&
    css`
      align-items: center;
      svg {
        margin-top: 0;
      }
    `}
`
